// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, maybe } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isGetMessagePrioritizationCategoriesResult = objectOf({
  hits: number,
  unread_changelog_count: maybe(number, true),
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: maybe(string, true),
      last_edited: string,
      last_edited_by: string,
      has_rule_dependencies: boolean,
    })
  ),
});
